import { matches } from 'lodash';
import Vue from 'vue'
import Vuex from 'vuex'

export default class {
    constructor() {
        Vue.use(Vuex);
        const state = {
					loading: true,
					error: false,
					listingsData: null,
					activeListingCount: null,
					topStyledListing: null,
					currentPage: 1,
					filterTags: null,
					navigableListings: null, 
					filteredListings: null,
				};
        const getters = {
					loading: state => state.loading,
					error: state => state.error,
					listingsData: state => state.listingsData,
					activeListingCount: state => state.activeListingCount,
					currentPage: state => state.currentPage,
					filterTags: state => state.filterTags,
					filteredListings: state => state.filteredListings,
					navigableListings: state => state.navigableListings,
					topStyledListing: state => state.topStyledListing
				};
        const mutations = {
					setStateValue(state, payload) {
						state[payload.key] = payload.value;
					},
					filterResults(state) {
						let allListings = state.navigableListings;
						let tags = state.filterTags;
						if (tags === null || tags.length === 0) {
							state.filteredListings = allListings;
						} else {
							let filteredArray =[];
							allListings.forEach(listing => {
								let matchesFilters = tags.every(tag => listing.tags.includes(tag));
								if (matchesFilters) filteredArray.push(listing);
							});
							state.filteredListings = filteredArray;
						}
					}
				};
        const actions = {
					setActiveListingCount({commit}, payload) {
						commit("setStateValue", { key: "activeListingCount", value: payload })
					},
					loadListingsData({commit}, payload) {
						return new Promise(resolve => {
							fetch(payload)
							.then(response => response.json())
							.then(data => {
								commit('setStateValue', { key: "listingsData", value: data})
							})
							.catch(error => {
								console.log(error);
								commit("setStateValue", { key: "error", value: "true" })
							})
							.finally(() => {
								setTimeout(() => {
									commit("setStateValue", { key: "loading", value: false });
									resolve();
								}, 750);
							});
						});
					},
					setNavigableListings({commit}, payload) {
						commit("setStateValue", { key: "navigableListings", value: payload })
					},
					setTopStyledListing({commit}, payload) {
						commit("setStateValue", { key: "topStyledListing", value: payload })
					},
					increaseActiveListingCount({commit}, payload) {
						commit("setStateValue", { key: "activeListingCount", value: state.activeListingCount + payload })
					},
					changePage({commit}, payload) {
						commit("setStateValue", { key: "currentPage", value: payload })
					},
					setFilterTags({commit}, payload) {
						commit("setStateValue", { key: "filterTags", value: payload })
					},
					setFilteredListings({commit}) {
						commit("filterResults")
					}
				};

        this.store = new Vuex.Store({
            state,
            getters,
            mutations,
            actions
        });
    }
}